/**
 * Version of the tour registry, recorded per user in
 * `vendor.properties.tourCompletions` when they finish or skip the tour.
 *
 * Bump it when adding steps that users who already finished the tour must be
 * shown; steps added without a bump reach new users only.
 */
export const TOUR_VERSION = 1;
